export function createRefMemo<TInput, TOutput>(
  compute: (input: TInput) => TOutput
): (input: TInput) => TOutput {
  let lastInput: TInput;
  let lastOutput: TOutput;
  let hasResult = false;

  return (input: TInput) => {
    if (hasResult && input === lastInput) return lastOutput;
    lastOutput = compute(input);
    lastInput = input;
    hasResult = true;
    return lastOutput;
  };
}
